<template>
  <Splide
    aria-label="Banners"
    :has-track="false"
    class="splide-dark-pagination aspect-image w-full xs:max-w-[calc(100vw-4rem)] mb-4"
    :options="options"
  >
    <SplideTrack class="rounded-2xl overflow-hidden">
      <SplideSlide v-if="loading">
        <SkeletonLoader class="w-full h-full aspect-image" />
      </SplideSlide>
      <SplideSlide
        v-if="zoomImage"
        class="overflow-hidden"
      >
        <ResponsiveImage
          :image="zoomImage"
          :width="400"
          :alt="product.title"
          loading="eager"
          class="w-full h-full object-cover animate-zoom aspect-image"
          @load="loading = false"
        />
      </SplideSlide>
      <SplideSlide
        v-for="(image, index) in sliderImages"
        :key="index"
      >
        <ResponsiveImage
          :image="image"
          :width="400"
          :alt="product.title"
          class="w-full h-full object-cover aspect-image"
          loading="lazy"
          @load="() => (index === 0 && !zoomImage) && (loading = false)"
        />
      </SplideSlide>
    </SplideTrack>
  </Splide>
</template>

<script setup lang="ts">
import { Splide, SplideSlide, SplideTrack, type Options } from '@splidejs/vue-splide'

import type { GraphqlBundleProduct } from '@/types/bundle'
import { computed, onMounted, ref, watch } from 'vue'
import ResponsiveImage from '../shared/v2/responsive-image.vue'
import SkeletonLoader from '../shared/v2/skeleton-loader.vue'

export interface Props {
  product: GraphqlBundleProduct
}

const loading = ref(true)

const IGNORE_ALT_REGEX = /profile|hover|cart/i

const props = defineProps<Props>()
const { images, zoomImage, flavorForwardImage } = props.product

const options: Options = {
  perPage: 1,
  rewind: true
}

const sliderImages = computed(() => {
  return images
    .slice(1)
    .filter(image => (
      !IGNORE_ALT_REGEX.test(String(image.altText))
      && !zoomImage?.url?.includes(image.url)
      && !flavorForwardImage?.url?.includes(image.url)
    ))
})

const handleVisibilityOfPagination = () => {
  const paginationElement = document.querySelector('.splide__pagination') as HTMLElement
  if (paginationElement) {
    paginationElement.style.visibility = loading.value ? 'hidden' : 'visible'
  }
}

onMounted(handleVisibilityOfPagination)
watch(loading, handleVisibilityOfPagination)
</script>
